var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgLogoSymbol = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    className,
    height = 441,
    titleId,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 441 441",
    className: className,
    height: height,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m315.708 281.197-10.062-28.595-13.251-37.652-9.586-27.249-12.548-35.661-14.577-41.421h-70.705l-11.286 32.074-10.063 28.595-49.974 142.015h46.633l14.629-41.453h70.718l-12.549-35.662h-45.672L197 208.94l20.021-56.9 3.309-9.418 3.31 9.418 56.72 161.23.013.033h46.632z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M412.554 112.354a8.996 8.996 0 0 0-12.252-3.416 8.994 8.994 0 0 0-3.416 12.252A202.438 202.438 0 1 1 18.767 238.032a202.44 202.44 0 0 1 155.295-214.66 202.44 202.44 0 0 1 140.257 17.7 27.521 27.521 0 1 0 9.38-15.388 220.434 220.434 0 1 0 88.855 86.671z"
  })));
});
export const Icon = /*#__PURE__*/React.forwardRef((_ref2, ref) => {
  let {
    className: propClassName = "",
    fill = "none",
    stroke = "currentColor",
    weight = "normal",
    height = 441,
    titleId,
    title,
    ...props
  } = _ref2;
  const className = "vector-effect-non-scaling-stroke " + propClassName;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 441 441",
    className: className,
    height: height,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m315.708 281.197-10.062-28.595-13.251-37.652-9.586-27.249-12.548-35.661-14.577-41.421h-70.705l-11.286 32.074-10.063 28.595-49.974 142.015h46.633l14.629-41.453h70.718l-12.549-35.662h-45.672L197 208.94l20.021-56.9 3.309-9.418 3.31 9.418 56.72 161.23.013.033h46.632z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M412.554 112.354a8.996 8.996 0 0 0-12.252-3.416 8.994 8.994 0 0 0-3.416 12.252A202.438 202.438 0 1 1 18.767 238.032a202.44 202.44 0 0 1 155.295-214.66 202.44 202.44 0 0 1 140.257 17.7 27.521 27.521 0 1 0 9.38-15.388 220.434 220.434 0 1 0 88.855 86.671z"
  })));
});
export default SvgLogoSymbol;
export const raw = __webpack_public_path__ + "static/media/LogoSymbol.4a03fc2fd70f33721c7dbbe5570338ac.svg";